import React, { useEffect } from 'react';
import { App as AntdApp, ConfigProvider, Layout, Space } from 'antd';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import initSentry from './sentry/sentry';
import { COLORS } from './constants';
import AppAuthenticatedRoutes from './app/AppAuthenticatedRoutes';
import AppGlobalFonts from './app/AppGlobalFonts';
import AppGuestRoutes from './app/AppGuestRoutes';
import SocketInitializerBridge from './app/SocketInitializerBridge';
import { AntdAppMessageBinder } from './utils/AntdAppMessageBinder';
import useSessionStore from './stores/useSessionStore';
import useWorkspaceStore from './stores/useWorkspaceStore';

import { headerHeight, getContentHeight } from './app/appLayoutConstants';

initSentry();

export { headerHeight };
export const contentHeight = getContentHeight();

const { Content } = Layout;

export default function App() {
  const loaded = useSessionStore((s) => s.loaded);
  const user = useSessionStore((s) => s.user);
  const fonts = useWorkspaceStore((s) => s.fonts);

  useEffect(() => {
    useWorkspaceStore.getState().checkUserAuthAndOrganizations().then(() => {
      useSessionStore.getState().setLoaded(true);
    });
  }, []);

  if (!loaded) {
    return null;
  }

  return (
    <>
      {fonts?.length > 0 && <AppGlobalFonts fonts={fonts} />}
      <ConfigProvider
        theme={{
          token: {
            fontFamily: 'Inter',
            colorPrimary: COLORS.mainViolet,
          },
        }}
      >
        <AntdApp>
          <AntdAppMessageBinder />
          <SocketInitializerBridge>
            <Layout style={{ height: '100vh', background: 'transparent' }}>
              {user ? (
                <Space direction="vertical" style={{ width: '100%' }}>
                  <Content style={{ margin: 0, height: '100vh' }}>
                    <AppAuthenticatedRoutes />
                  </Content>
                </Space>
              ) : (
                <AppGuestRoutes />
              )}
            </Layout>
          </SocketInitializerBridge>
        </AntdApp>
      </ConfigProvider>
    </>
  );
}
